@if (configuration.window.canDisableMuntins) {
  <mat-checkbox
    class="disableMuntinsCheckbox"
    [(ngModel)]="muntinsDisabled"
    (change)="disableAndRemoveMuntins($event.checked)"
    >{{ 'WINDOW|Bez szprosów' | translate }}</mat-checkbox
    >
  }
  <div class="muntinsStepComponent">
    <button
      [disabled]="muntinsDisabled"
      mat-raised-button
      color="primary"
      (click)="openModalMuntinsLayout()"
      matRipple
      >
      {{ 'WINDOW|Wybierz układ szprosów' | translate | uppercase }}
    </button>

    <button
      [disabled]="muntinsDisabled"
      mat-raised-button
      color="primary"
      (click)="openModalMuntinsManualLayout()"
      matRipple
      >
      {{ 'WINDOW|Szprosy niestandardowe' | translate | uppercase }}
    </button>

    @if (!configuration.window.muntinTypesModal) {
      <mat-form-field class="muntinsSelect">
        <mat-label>{{ 'WINDOW|Typ szprosów' | translate }}</mat-label>
        <mat-select [disabled]="muntinsDisabled" (selectionChange)="changeType($event)" [value]="(muntinsType$ | async)?.id">
          @for (type of types; track type) {
            <mat-option trackBy="type.id" [value]="type.id">
              {{ type.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (configuration.window.muntinTypesModal) {
      <icc-select-box
        [disabled]="muntinsDisabled"
        [title]="'WINDOW|Typ szprosów:' | translate"
        [description]="(muntinsType$ | async)?.name"
        [imageUrl]="'/files/windowbartype/' + ((muntinsType$ | async)?.img || '')"
        [buttonText]="'INTERFACE|Zmień' | translate"
        [disabledButton1]="types.length <= 1"
        (select)="openModalTypes()"
      ></icc-select-box>
    }

    <mat-form-field class="muntinsSelect">
      <mat-label>{{ 'WINDOW|Szerokość szprosa' | translate }}</mat-label>
      <mat-select [disabled]="muntinsDisabled" (selectionChange)="changeWidth($event)" [value]="muntinsSizeId$ | async">
        @for (size of (muntinsType$ | async)?.sizes || []; track size) {
          <mat-option trackBy="size.id" [value]="size.id">
            {{ (size.size | unitmm:1:0:'':null:' ') }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <icc-select-box
      [disabled]="muntinsDisabled"
        [title]="
            (showSecondColor$ | async)
                ? ('WINDOW|Kolor wewnętrzny' | translate)
                : ('COLOR|Kolor szprosa' | translate)
        "
      [description]="(muntinsColorInner$ | async)?.name || ''"
      [imageUrl]="'/files/color/' + (muntinsColorInner$ | async)?.colorImg || ''"
      [color]="'#' + (muntinsColorInner$ | async)?.color || ''"
      [colorSelect]="true"
      [buttonText]="'INTERFACE|Zmień' | translate"
      (select)="openModalColor('in')"
    ></icc-select-box>

    @if ((showSecondColor$ | async)) {
      <icc-select-box
        [disabled]="muntinsDisabled"
        [title]="'WINDOW|Kolor zewnętrzny' | translate"
        [description]="(muntinsColorOuter$ | async)?.name || ''"
        [imageUrl]="'/files/color/' + (muntinsColorOuter$ | async)?.colorImg || ''"
        [color]="'#' + (muntinsColorOuter$ | async)?.color || ''"
        [colorSelect]="true"
        [buttonText]="'INTERFACE|Zmień' | translate"
        (select)="openModalColor('out')"
      ></icc-select-box>
    }

    @if (isDuplexAvailable()) {
      <mat-slide-toggle
        [disabled]="muntinsDisabled"
        class="duplex-slider"
        (change)="changeDuplex($event)"
        [checked]="duplex$ | async"
        >
        {{ 'WINDOW|Dupleks' | translate }}
      </mat-slide-toggle>
    }

    @if ((muntinsTypeContext$ | async); as context) {
      <p [innerHTML]="context" class="muntin-type-description"></p>
    }
  </div>
